import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('brandos_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('brandos_token');
      localStorage.removeItem('brandos_user');
      window.location.href = '/auth';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  verifyEmail: (data) => api.post('/auth/verify-email', data),
  resendVerification: (data) => api.post('/auth/resend-verification', data),
  forgotPassword: (data) => api.post('/auth/forgot-password', data),
  resetPassword: (data) => api.post('/auth/reset-password', data),
};

export const onboardingAPI = {
  parse: (slug, data) => api.post(`/onboarding/parse/${slug}`, data),
  save: (slug, data) => api.post(`/onboarding/save/${slug}`, data),
  complete: () => api.post('/onboarding/complete'),
  getSuggestedProducts: () => api.get('/onboarding/suggested-products'),
  confirmProducts: (data) => api.post('/onboarding/confirm-products', data),
};

export const categoryAPI = {
  getAll: () => api.get('/categories'),
  getOne: (slug) => api.get(`/categories/${slug}`),
  update: (slug, data) => api.put(`/categories/${slug}`, data),
  toggleLock: (slug) => api.put(`/categories/${slug}/lock`),
  getMeta: () => api.get('/categories/meta/all'),
};

export const notificationAPI = {
  getAll: () => api.get('/notifications'),
  markRead: (id) => api.put(`/notifications/${id}/read`),
  markAllRead: () => api.put('/notifications/read-all'),
  remove: (id) => api.delete(`/notifications/${id}`),
  addProduct: (id) => api.post(`/notifications/${id}/add-product`),
  generate: () => api.post('/notifications/generate'),
};

export const productAPI = {
  getAll: () => api.get('/products'),
  add: (data) => api.post('/products', data),
  remove: (id) => api.delete(`/products/${id}`),
};

export const insightAPI = {
  getAll: () => api.get('/insights'),
};

export const taskAPI = {
  getToday: () => api.get('/tasks/today'),
  getCalendar: (date) => api.get(`/tasks/calendar/${date}`),
  toggle: (taskId, date) => api.put(`/tasks/${taskId}/toggle`, date ? { date } : {}),
  getWeekScore: () => api.get('/tasks/week-score'),
  getMonthlySummary: () => api.get('/tasks/monthly-summary'),
  addNote: (data) => api.post('/tasks/add-note', data),
  getNotes: (date) => api.get(`/tasks/notes/${date}`),
  deleteNote: (noteId) => api.delete(`/tasks/notes/${noteId}`),
};

export const photoAPI = {
  upload: (data) => api.post('/photos/upload', data),
  getByCategory: (category) => api.get(`/photos/${category}`),
};

export const statusAPI = {
  generateReference: (data) => api.post('/status/generate-reference', data),
  submitPhoto: (data) => api.post('/status/submit-photo', data),
};

export const profileAPI = {
  update: (data) => api.put('/profile/update', data),
  changeEmail: (data) => api.post('/profile/change-email', data),
  verifyEmailChange: (data) => api.post('/profile/verify-email-change', data),
  changePassword: (data) => api.post('/profile/change-password', data),
  cancelSubscription: (data) => api.post('/subscription/cancel', data),
};

export const debloatAPI = {
  generate: (formData) => api.post('/debloat/generate', formData, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 }),
  setGoal: (goalPercent) => api.post('/debloat/set-goal', { goal_percent: goalPercent }),
  getStatus: () => api.get('/debloat/status'),
};

export default api;
